import { Link } from "react-router-dom"
import "./Settings.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus,faUserMinus,faUserEdit,faMoneyCheckAlt,faChartPie,faHandHoldingDollar,faPauseCircle } from '@fortawesome/free-solid-svg-icons'


function Settings(){  

    const Cards = [ 
        { 
            "Title" : "Add User", 
            "Count" : faUserPlus,
            "Link" : "/Dashboard/AddUser"
        },
        { 
            "Title" : "Remove User", 
            "Count" : faUserMinus,
            "Link" : "/Dashboard/DeleteUser"
        },
        { 
            "Title" : "Edit User", 
            "Count" : faUserEdit,
            "Link" : "/Dashboard/EditUser"
        },
        { 
            "Title" : "Finances", 
            "Count" : faMoneyCheckAlt,
            "Link" : "/Dashboard/Transact"
        },
        { 
            "Title" : "Pay Reports", 
            "Count" : faChartPie,
            "Link" : "/Dashboard/Reports"
        },
        { 
            "Title" : "Deductions Reports", 
            "Count" : faHandHoldingDollar,
            "Link" : "/Dashboard/AdvanceReports"
        },
        { 
            "Title" : "Pending", 
            "Count" : faPauseCircle,
            "Link" : "/Dashboard/AddUser"
        },
    ]

    const announce =  [
        {  
            "Date" : "11/11/2022",
            "anna" : "100,000 ZMW withdraw"
        },
        {  
            "Date" : "15/11/2022",
            "anna" : "joshua edited transaction status"
        },
        {  
            "Date" : "15/11/2022",
            "anna" : "1,000,000 ZMW deposit"
        },
        {  
            "Date" : "11/20/2022",
            "anna" : "Something important here"
        },


]

    return( 

        <>
             <div className="overviewCover">  
                 
                 <div className="mainOverview">
                    
                       <h1>Operations</h1>

                
                 </div>

                 <div className="Analytics">  
                    <div  className="minHeading"></div>
                    <div className="Content"> 
                                <div className="cards">
                                    <div className="card"> 
                                     {Cards.map((item,key)=>{ 
                                          return( 
                                            <div key={key} className="inCard"> 

                                             <div className="cardIcon"><FontAwesomeIcon icon={item.Count} className="FontAwesomeIcon"/></div>
                                                 <div className="cardDetail">
                                                   
                                                   <Link className="linkItem" to={item.Link}><p>{item.Title}</p> </Link>
                                                   {/* <p>{item.Count}</p>  */}

                                             </div>

                                            </div>
                                          )

                                     })}
                                        
                                    </div>
                                </div>
                                {/* <div className="Announcements"> 

                                            <div className="annoucement">
                                                <div className="annHead">
                                                    <div>
                                                        <h3>Announcements</h3>
                                                   
                                                    </div> 
                                                    {announce.map((item,key)=>{
                                                        return(
                                                            <div className="annCard">
                                                                <div className="cardData"> <p>{item.Date}</p></div>
                                                               
                                                                <p>{item.anna}</p>
                                                            </div>
                                                        )
                                                    })}
                                                    
                                                </div>

                                            </div>

                                </div> */}
                    </div>

                 </div>


            </div>
                
        </>
    )
}

export default Settings;